import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({
  username: Yup.string().required(),
  password: Yup.string()
    .required()
    .min(8)
});

export const forgotPasswordSchema = Yup.object().shape({
  username: Yup.string().required()
});

export const changePasswordSchema = Yup.object().shape({
  username: Yup.string().required(),
  newPassword: Yup.string()
    .required()
    .matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/),
  code: Yup.string().required()
});

export const newPasswordSchema = Yup.object().shape({
  newPassword: Yup.string()
    .required()
    .required()
    .matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)
});
